import { render, staticRenderFns } from "./uniformGoods.vue?vue&type=template&id=8c562df8&scoped=true"
import script from "./uniformGoods.vue?vue&type=script&lang=js"
export * from "./uniformGoods.vue?vue&type=script&lang=js"
import style0 from "./uniformGoods.vue?vue&type=style&index=0&id=8c562df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c562df8",
  null
  
)

export default component.exports